import Testing from './Testing';

export default Testing;
